
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.353 1.412a.941.941 0 00-.941.94v11.441c0 .44.356.795.795.795h3.31c.305 0 .6.46.6.766 0 .304-.295.646-.6.646h-3.31c-.583 0-1.146-.23-1.557-.646a2.193 2.193 0 01-.65-1.56V2.206C0 1.623.231 1.06.65.647A2.192 2.192 0 012.207 0h3.31c.305 0 .492.342.492.646 0 .305-.057.766-.362.766H2.353zM10.823 3.08c.232-.216.709-.216.94 0l1.884 1.882 2.352 2.353c.47.47.47.47-.47 1.412l-1.883 1.882-1.882 1.883c-.232.216-.71.216-.941 0-.232-.217-.232-.725 0-.941l3.742-3.72-3.742-3.81c-.232-.216-.232-.725 0-.941z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.706 7.81c0-.39.253-.707.565-.707h10.164c.312 0 .565.316.565.706 0 .39-.253.706-.565.706H5.271c-.312 0-.565-.316-.565-.706z","fill":"#585858"}})])
          )
        }
      }
    